module.exports = __webpack_public_path__ + "img/Vue-icon.e42c9322.svg";